import React from 'react';
import LegalLayout from './LegalLayout';
import './legal.css';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h3 className="text-xl font-semibold text-gray-800 mb-3">{title}</h3>
    <div className="text-gray-600 space-y-3">{children}</div>
  </section>
);

const PrivacyPolicy = () => (
  <LegalLayout title="Privacy Policy">
    <div className="prose max-w-none">
      <h2 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h2>
      <p className="text-gray-500 mb-6">Last updated: August 22, 2026</p>

      <Section title="1. Who we are">
        <p>SmushLabs operates SmushChat at smushlabs.ai. Questions and privacy requests can be sent to support@smushlabs.ai.</p>
      </Section>
      <Section title="2. Information we process">
        <ul className="list-disc pl-6">
          <li>Account and contact information you provide, such as your name and email address.</li>
          <li>Billing and subscription records. Payment providers process payment-card information on their systems.</li>
          <li>Content you choose to upload or connect as a knowledge source.</li>
          <li>Chat messages, form responses, and conversation metadata processed to provide the service.</li>
          <li>Technical information such as IP address, browser, device, pages viewed, and diagnostic events.</li>
        </ul>
      </Section>
      <Section title="3. Why we process information">
        <p>We use information to provide and secure SmushChat, create requested demos, process subscriptions, answer support requests, diagnose problems, and understand how our public website and product are used.</p>
      </Section>
      <Section title="4. Website analytics and Microsoft Clarity">
        <p>We use Microsoft Clarity to understand website interactions through measures such as page visits, clicks, scrolling, device information, and session replays. Clarity may use cookies or similar technologies and processes this data under Microsoft&apos;s privacy terms.</p>
        <p>We also use Google Analytics and Google Tag Manager on the public website for aggregated traffic and campaign measurement.</p>
      </Section>
      <Section title="5. Knowledge sources and chatbot conversations">
        <p>Customers control the business content they connect to SmushChat. Customers are responsible for having permission to use that content and for providing appropriate notices to their own website visitors. SmushChat uses connected knowledge to retrieve context and produce responses; AI responses can be incorrect and should be reviewed for sensitive or high-impact uses.</p>
      </Section>
      <Section title="6. Sharing and service providers">
        <p>We share data only as needed with infrastructure, authentication, payment, email, analytics, and AI service providers that help us operate SmushChat, or when required by law. We do not sell personal information.</p>
      </Section>
      <Section title="7. Retention and security">
        <p>We retain information only for as long as needed to provide the service, meet legal obligations, resolve disputes, and maintain security. We use reasonable technical and organizational safeguards, but no online service can guarantee absolute security.</p>
      </Section>
      <Section title="8. Your choices and rights">
        <p>Depending on where you live, you may request access, correction, deletion, restriction, objection, or portability of personal information. You may also withdraw consent where processing is based on consent.</p>
      </Section>
      <Section title="9. Contact">
        <p>Email: support@smushlabs.ai</p>
        <p>Address: Tulsi 117, Sahara Sunderban, Phase II, Jamshedpur, Jharkhand 831012, India</p>
      </Section>
    </div>
  </LegalLayout>
);

export default PrivacyPolicy;
